import { render, staticRenderFns } from "./category_companies.html?vue&type=template&id=474ff1b4&external"
import script from "./category_companies.vue?vue&type=script&lang=js"
export * from "./category_companies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports